/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup,UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { PartsOrServicesFieldOptions } from './update-parts-services.interface';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MarkupEventAnalyticsService } from 'app/core/services/analytics/markup-event-analytics.service';
import { EditorOptions } from '../text-editor/text-editor.interface';
@Component({
  selector: 'update-parts-services.component',
  templateUrl: './update-parts-services.component.html',
  styleUrls: ['./update-parts-services.component.scss']
})
export class UpdatePartsOrServicesComponent implements OnInit, OnDestroy, AfterViewInit {
  updatePartsOrServicesForm: UntypedFormGroup;
  partsFormFields: Array<PartsOrServicesFieldOptions>;
  productDetailsData: any;
  companyCurrency: any;
  discountType: any = [];
  showRecurrence: boolean = false;
  locationName: string;
  serialNumbers: any = [];
  showPrice: boolean = false;
  showTaxPreference: boolean = false;
  companyConfig: any;
  overallDiscountType: any;
  user: any;
  markupType: string = 'FLAT';
  markupValueSubscription: Subscription;
  currencyDecimal: number = this.utilityService.getCurrencyDecimal();
  purchasePrice: number;
  showEditor: boolean = false;
  textEditorOptions: EditorOptions = {
    editorId:'partDescription',
    attachmentType: 'JOB_NOTE',
    module:'PRODUCT',
    isForm: true,
    showTemplate: false,
    showTable: false,
  };
  stepValue = this.utilityService.stepValue;
  taxCode: string;

  //permissions
  isEditSellingPriceDisabled: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UpdatePartsOrServicesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    public utilityService: UtilityService,
    private markupEventAnalyticsService: MarkupEventAnalyticsService,
    private localStorageService: LocalStorageService){
      this.companyCurrency = this.localStorageService.getLocalStorage('company')?.company_currency ?? 'USD';
      this.companyConfig = this.localStorageService.getLocalStorage('company_configuration_data');
      this.overallDiscountType = this.companyConfig.general?.discount?.discount_type ?  this.companyConfig.general.discount.discount_type : 'FIXED';
      this.discountType = [{key:this.companyCurrency,value:'FIXED'},{key:'%', value:'PERCENTAGE'}];
      this.showPrice = this.utilityService.hasPermission('product.show_selling_price') ?? false;
      this.partsFormFields = this.data?.options?.fieldOptions;
      this.productDetailsData = this.data?.product;
      this.user = this.utilityService.user;
      this.showRecurrence = this.data?.is_recurrence;
      if (!this.productDetailsData?.product_uid && !this.showPrice && this.data?.options?.type === 'new') {
        this.showPrice = true;
      }
      if(this.data?.options?.type === 'edit'){
        this.isEditSellingPriceDisabled = !this.utilityService.hasPermission('product.edit_selling_price');
      }
      this.markupType = this.companyConfig?.product?.default_markup_type ?? 'FLAT';
      this.buildFormFields();
    }

    buildFormFields(): void{
      let formFields = {};
      const isEditDialogType: boolean = this.data?.options?.type === 'edit';
      if(this.partsFormFields?.length){
        this.partsFormFields.forEach((element: any)=>{
        let validators = [];
        if(element?.isRequired){
          validators = [...validators,Validators.required];
        }
        if(element?.showField && (element?.displayType ==='input')){
          if(['price','unit_price','purchase_price','selling_price'].includes(element?.fieldName)){
            validators = [...validators,Validators.min];
          }

          if (['planned_quantity','quantity'].includes(element?.fieldName)) {
            validators = [...validators,this.utilityService.numberMinValueValidator];
          }

          formFields = {...formFields, [element?.fieldName]: new UntypedFormControl({
                                                                              value: isEditDialogType ?
                                                                                        (element?.fieldName === 'location_uid' ? this.productDetailsData[element?.fieldName] || '' : this.productDetailsData[element?.fieldName]):  null,
                                                                              disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false},
                                                                              validators)
                        };
          if (element?.fieldName === "planned_quantity") {
            const value =
              this.data?.options?.type === "edit"
                ? this.productDetailsData["planned"] &&
                  this.productDetailsData["planned"]["quantity"]
                  ? this.productDetailsData["planned"]["quantity"]
                  : 0
                : 0;

            formFields = {
              ...formFields,
              planned_quantity: new UntypedFormControl(
                {
                  value: value,
                  disabled:
                    !this.utilityService.isEmptyOrUndefined(
                      element?.isEditable
                    ) && [true, false].includes(element?.isEditable)
                      ? !element?.isEditable
                      : false,
                },
                validators
              ),
            };
          }
          if(element?.fieldName === 'discount'){
            const discountType = isEditDialogType ? (this.productDetailsData['discount_type'] && this.productDetailsData['discount']) ? this.productDetailsData['discount_type'] : this.overallDiscountType : this.overallDiscountType;
            const discount = isEditDialogType ? this.productDetailsData['discount'] ?? '' : '';

            formFields = {...formFields, 'discount_type': new UntypedFormControl({
              value: discountType,
              disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false},
              validators)
            };
            if(discountType === 'FIXED' && isEditDialogType){
              const quantity = this.productDetailsData['quantity'];
              const price = this.productDetailsData['price'] ?? this.productDetailsData['unit_price'];
              const maxDiscountValue = this.getMaxValue(quantity,price);
              validators = [...validators,Validators.min(0),Validators.max(maxDiscountValue)];
            }
            formFields = {
              ...formFields,'discount': new UntypedFormControl({
                value: discount,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false},
                validators)
            };
          };
          if (element?.fieldName === 'is_billable') {
            let is_billable: boolean = true;
            if (this.productDetailsData?.hasOwnProperty('is_billable')) {
              is_billable = this.productDetailsData?.is_billable;
            }
            formFields = {
              ...formFields, 'is_billable': new UntypedFormControl({
                value: is_billable,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false
              },
                validators)
            };
          }
          if(element?.fieldName === 'tax_preference'){
            this.showTaxPreference = true;
            let taxPreferenceControlValue: boolean = false;
            if(this.productDetailsData?.hasOwnProperty('tax')){
              if(this.productDetailsData.tax?.hasOwnProperty('tax_exempt')){
                taxPreferenceControlValue = this.productDetailsData.tax.tax_exempt;
              }
            }
            formFields = {...formFields, 'tax_preference': new UntypedFormControl({
              value: taxPreferenceControlValue,
              disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false},
              validators)
            };
          }
          if(element?.showField && element?.fieldName === 'serial_nos'){
            this.serialNumbers = this.getSerialNumbers();
            formFields = {...formFields, [element?.fieldName]: new UntypedFormControl({
              value: isEditDialogType ? this.productDetailsData[element?.fieldName] : [],
              disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false},
              validators)
          };
          }
          if(element?.fieldName === 'location_uid'){
            this.locationName = this.getLocationName(this.productDetailsData[element?.fieldName]);
          }
          if(element?.fieldName === 'tax_code'){
            if(this.productDetailsData?.tax?.tax_code){
              this.taxCode = this.productDetailsData?.tax?.tax_code;
            }
            formFields = {
              ...formFields,'tax_code': new UntypedFormControl({
                value: this.taxCode,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false},
                validators)
            };
          }
        }
        if(element?.fieldName === 'markup'){
          if((this.companyConfig?.product?.enable_markup === true) && ((this.user?.role?.role_key === 'ADMIN') || this.showPrice)){
            element.showField = true;
            let markupValue: number;
            if(this.productDetailsData?.hasOwnProperty('markup')){
              if(this.productDetailsData.markup?.markup_value && this.productDetailsData.markup?.markup_type){
                markupValue = this.productDetailsData.markup.markup_value;
                this.markupType = this.productDetailsData.markup.markup_type ?? this.companyConfig?.product?.default_markup_type;
              }
            }
            formFields = {...formFields, 'markup': new UntypedFormControl({
              value: this.productDetailsData?.price > 0 ? markupValue : null,
              disabled: (!this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false) || (this.data?.options?.type === 'new' || this.productDetailsData?.price < 0)
              },
              validators
              )
            };
          }
        }
        if(element?.fieldName === 'purchase_price'){
          const isValidPurchasePrice = !this.utilityService.isEmptyOrUndefined(this.productDetailsData?.purchase_price);
          const isValidProductPurchasePrice = this.utilityService.isEmptyOrUndefined(this.productDetailsData?.product_ref_id?.purchase_price);
          const isValidUnitPrice = !this.utilityService.isEmptyOrUndefined(this.productDetailsData?.unit_price_premarkup);
          const isValidProductUnitPrice = this.utilityService.isEmptyOrUndefined(this.productDetailsData?.product_ref_id?.unit_price_premarkup);
          const isValidPrice = !this.utilityService.isEmptyOrUndefined(this.productDetailsData?.price);
          const isValidProductPrice = this.utilityService.isEmptyOrUndefined(this.productDetailsData?.product_ref_id?.price);
          const isParentModule = this.data?.options?.parentModule;

          if(isValidPurchasePrice || isValidProductPurchasePrice){
           this.purchasePrice = this.productDetailsData?.purchase_price ?? this.productDetailsData?.product_ref_id?.purchase_price;
          }
          else if(!isParentModule && (isValidUnitPrice || isValidProductUnitPrice)){
            this.purchasePrice = this.productDetailsData?.unit_price_premarkup ?? this.productDetailsData?.product_ref_id?.unit_price_premarkup;
          }
          else if(!isParentModule && (isValidPrice || isValidProductPrice)){
            this.purchasePrice = this.productDetailsData?.price ?? this.productDetailsData?.product_ref_id?.price;
          };

          const isDisabled = !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false;

          formFields = {...formFields, 'purchase_price': new UntypedFormControl({
            value: this.purchasePrice,
            disabled:  this.isEditSellingPriceDisabled || isDisabled
          },
            validators
            )
          };
        }
        if(element?.fieldName === 'price'){
          validators = ['text.unit_selling_price'].includes(element.fieldLabel) ? validators.filter(item => item.name !== 'min'):validators;
          const sellingPrice = this.productDetailsData?.price ?? null;
          const isSellingPriceDisabled = this.productDetailsData?.markup?.markup_value > 0;
          const isDisabled = !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false;
          formFields = {...formFields, 'price': new UntypedFormControl({
            value: sellingPrice,
            disabled: this.isEditSellingPriceDisabled || isDisabled || isSellingPriceDisabled,
           },
           validators
          )
          };
        }
        if (['price','unit_price','purchase_price','selling_price', 'discount', 'markup'].includes(element?.fieldName) && !this.showPrice) {
          element.showField = false;
        }
      });
      }

      if(this.showRecurrence){
        formFields = {...formFields, update_all_jobs : new UntypedFormControl({value: false,disabled: false})};
      }
      this.updatePartsOrServicesForm = this.formBuilder.group(formFields);

      const isPurchasePriceNotValid = this.utilityService.isEmptyOrUndefined(this.productDetailsData?.purchase_price);
      const isMarkupNotValid = this.utilityService.isEmptyOrUndefined(this.productDetailsData?.markup?.markup_value);
      if(isEditDialogType && isPurchasePriceNotValid && isMarkupNotValid){
        this.updatePartsOrServicesForm.controls?.markup?.setValue('');
      }

      const serialNumberControl = this.updatePartsOrServicesForm.get('serial_nos');
      if(serialNumberControl){
        serialNumberControl.addValidators(this.validateSerialNo.bind(this));
        serialNumberControl?.updateValueAndValidity();
      }

      this.updatePartsOrServicesForm.controls?.quantity?.valueChanges.subscribe((response: any)=>{
        this.updatePartsOrServicesForm.controls?.serial_nos?.updateValueAndValidity();
        if(this.updatePartsOrServicesForm.value.discount_type === 'FIXED'){
          this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          const price = this.updatePartsOrServicesForm.value?.price ?? this.updatePartsOrServicesForm.value?.unit_price ?? 0;
          this.updatePartsOrServicesForm?.controls?.discount?.addValidators(Validators.max(this.getMaxValue(response, price)));
          this.updatePartsOrServicesForm.controls?.discount?.updateValueAndValidity();
        }
      });

      this.updatePartsOrServicesForm.controls?.price?.valueChanges.subscribe((response)=>{
        if(this.updatePartsOrServicesForm?.controls?.discount_type?.value === 'FIXED'){
          this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          const quantity = this.updatePartsOrServicesForm?.controls?.quantity?.value;
          if(response >= 0){
            this.updatePartsOrServicesForm?.controls?.discount?.addValidators(Validators.max(this.getMaxValue(quantity,response)));
          }else{
            this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          }
          this.updatePartsOrServicesForm.controls?.discount?.updateValueAndValidity();
        }else{
          this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          this.updatePartsOrServicesForm.controls?.discount?.updateValueAndValidity();
        }
      });

      this.updatePartsOrServicesForm.controls?.unit_price?.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response: any)=>{
        if(this.updatePartsOrServicesForm?.controls?.discount_type?.value === 'FIXED'){
          this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          const quantity = this.updatePartsOrServicesForm?.controls?.quantity?.value;
          if(response >= 0){
            this.updatePartsOrServicesForm?.controls?.discount?.addValidators(Validators.max(this.getMaxValue(quantity,response)));
          }else{
            this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          }
          this.updatePartsOrServicesForm.controls?.discount?.updateValueAndValidity();
        }else{
          this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          this.updatePartsOrServicesForm.controls?.discount?.updateValueAndValidity();
        }
      });

      this.updatePartsOrServicesForm.controls?.discount_type?.valueChanges.pipe(debounceTime(500),distinctUntilChanged()).subscribe((response: any)=>{
        if(response === 'FIXED'){
          const quantity = this.updatePartsOrServicesForm.value?.quantity;
          const price = this.updatePartsOrServicesForm?.controls?.price?.value ?? this.updatePartsOrServicesForm?.controls?.unit_price?.value ?? 0;
          if(price >= 0){
            this.updatePartsOrServicesForm?.controls?.discount?.addValidators(Validators.max(this.getMaxValue(quantity,price)));
          }else{
            this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
          }
        }else{
          this.updatePartsOrServicesForm?.controls?.discount?.clearValidators();
        }
        this.updatePartsOrServicesForm.controls?.discount?.updateValueAndValidity();
      });

      if(this.updatePartsOrServicesForm.controls?.purchase_price){
        this.updatePartsOrServicesForm.controls?.purchase_price.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response: any)=>{
            if (response >= 0) {
              this.updatePartsOrServicesForm.controls?.markup?.enable({emitEvent: false});
              this.purchasePrice = this.updatePartsOrServicesForm.controls?.purchase_price.value;
              const markupValue = this.updatePartsOrServicesForm.controls?.markup?.value;
              const isNewCustomLineItem = (this.data?.options?.type === 'new' && this.data?.options?.lineItemType === 'CUSTOM');
              const hasMarkUpValue = !this.utilityService.isEmptyOrUndefined(markupValue) && markupValue >= 0;
              if(isNewCustomLineItem || hasMarkUpValue){
                this.updateSellingPrice(markupValue);
              }
            } else {
              this.updatePartsOrServicesForm.controls?.markup.setValue(null);
              this.markupType = this.companyConfig?.product?.default_markup_type ?? 'FLAT';
              this.updatePartsOrServicesForm.controls?.markup?.disable();
              const markupValue = this.updatePartsOrServicesForm.controls?.markup?.value;
              this.updateSellingPrice(markupValue);
          }

        });
      }

      if(this.updatePartsOrServicesForm.controls?.markup){
        this.markupValueSubscription = this.updatePartsOrServicesForm.controls.markup.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response: any)=>{
          if(!this.utilityService.isEmptyOrUndefined(response) && response >= 0){
            this.updateSellingPrice(response);
          }else{
            this.updateSellingPrice(null);
          }
        });
      }
      this.updatePartsOrServicesForm.controls.price.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response: any)=>{
        if((response >= 0 || response === null) && !this.utilityService.isEmptyOrUndefined(this.updatePartsOrServicesForm.controls?.purchase_price?.value)){
          this.updatePartsOrServicesForm.controls?.markup?.enable({ emitEvent: false });
        }else{
          this.updatePartsOrServicesForm.controls?.markup?.disable({ emitEvent: false });
        }
      });
    }

    changeTaxCode(event: any): void {
      const taxcode = this.updatePartsOrServicesForm.get('tax_code') as UntypedFormControl;
      this.taxCode = event;
      taxcode.setValue(event);
    }

    getMaxValue(quantity,price): any{
      const maxValue = quantity * price;
      return maxValue;
    }

    get availableLocations(): any{
      if(this.productDetailsData?.product_ref_id && this.productDetailsData.product_ref_id?.location_availability){
        return this.productDetailsData?.product_ref_id?.location_availability;
      }else{
        return this.productDetailsData?.location_availability;
      }
    }

    getRequiredErrorMessage(fieldName): string{
      const field = fieldName.replace('_',' ');
      return `${field.charAt(0).toUpperCase()}${field.slice(1)} ${this.utilityService.getLocaleValue('reports.details.is_required')}`;
    }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showEditor = true;
    }, 500);
  }

  updatePartsOrServices(): void{
    this.updatePartsOrServicesForm.markAllAsTouched();
    if(this.updatePartsOrServicesForm?.valid){
      const partsOrServiceData = this.updatePartsOrServicesForm.value;
      const unitPrice = this.updatePartsOrServicesForm.controls?.price?.value;
      if(this.updatePartsOrServicesForm.controls?.location_name ?? this.locationName){
        partsOrServiceData['location_name'] = this.locationName;
      }else{
        partsOrServiceData['location_name'] = '';
      }
      if(this.utilityService.isEmptyOrUndefined(this.updatePartsOrServicesForm.value['price'])){
        partsOrServiceData['price'] = unitPrice;
      }
      partsOrServiceData['is_billable'] = partsOrServiceData['is_billable'] ?? true;
      if(this.showTaxPreference){
        const taxPayload = {
          tax_exempt:'',
        };
        const productLevelTax = this.productDetailsData?.tax;
        const productMasterTax = this.productDetailsData?.product_ref_id;
        if(productLevelTax?.tax_rate && productLevelTax?.tax_name){
          taxPayload['tax_name'] = this.productDetailsData.tax.tax_name;
          taxPayload['tax_rate'] = this.productDetailsData.tax.tax_rate;
        }else if(productMasterTax?.tax?.tax_name && productMasterTax?.tax?.tax_rate){
          taxPayload['tax_name'] = productMasterTax.tax.tax_name;
          taxPayload['tax_rate'] = productMasterTax.tax.tax_rate;
        }
        taxPayload.tax_exempt = partsOrServiceData['tax_preference'];
        partsOrServiceData['tax'] = taxPayload;
      }
      if(!this.utilityService.isEmptyOrUndefined(this.updatePartsOrServicesForm.controls?.markup?.value)){
        const markupPayload = {
          markup_type:this.markupType,
          markup_value: this.updatePartsOrServicesForm.controls?.markup?.value,
        };
        partsOrServiceData['markup'] = markupPayload;
        partsOrServiceData['unit_price_premarkup'] = this.purchasePrice;
      }else{
        delete partsOrServiceData['markup'];
      }
      delete partsOrServiceData['tax_preference'];
      this.dialogRef.close({...partsOrServiceData,unit_price : unitPrice});
    }
  }

  getSerialNumbers(): any{
    let serialNumbers: string[] = [];
    if (this.productDetailsData?.product_ref_id?.serial_nos) {
      serialNumbers = this.productDetailsData?.product_ref_id?.serial_nos;
    }else if(this.productDetailsData?.product?.serial_nos){
      serialNumbers = this.productDetailsData?.product?.serial_nos;
    }
    if (this.productDetailsData?.product_ref_id?.location_availability) {
      let productLocationData = this.productDetailsData?.product_ref_id?.location_availability;
      if(this.productDetailsData?.location_uid){
        productLocationData = productLocationData?.filter((data: any)=> data?.location?.location_uid === this.productDetailsData?.location_uid);
      }
      productLocationData?.forEach((location: any) => {
        if(location?.serial_nos){
          serialNumbers = [...serialNumbers,...location?.serial_nos];
        }
      });
    }else if(this.productDetailsData?.product?.location_availability){
      let productLocationData = this.productDetailsData?.product?.location_availability;
      if(this.productDetailsData?.location_uid){
        productLocationData = productLocationData?.filter((data: any)=>  data?.location?.location_uid === this.productDetailsData?.location_uid);
      }
      productLocationData?.forEach((location: any) => {
        serialNumbers = [...serialNumbers,...location?.serial_nos];
      });
    }

    return serialNumbers;
  }

  validateSerialNo(controller: AbstractControl): any {
    if (controller.value?.length > 0 && controller.value?.length !== this.updatePartsOrServicesForm.get('quantity').value)  {
      return {
        invalidSerialNo: true,
      };
    }
    return null;
  }

  getLocationName(location_uid): string{
    if(this.productDetailsData?.product_ref_id && this.productDetailsData.product_ref_id?.location_availability){
      return this.productDetailsData?.product_ref_id?.location_availability?.find((data: any)=>data?.location?.location_uid === location_uid)?.location?.location_name;
    }else{
      return this.productDetailsData?.location_availability?.find((data: any)=>data?.location?.location_uid === location_uid)?.location?.location_name;
    }
  }

  locationNameChange(event): void{
    const location_uid = event.value;
    const locationArray = this.availableLocations.filter(locationDetails =>  locationDetails?.location?.location_uid === location_uid);
    this.locationName = locationArray[0]?.location?.location_name ?? '';
    if(this.updatePartsOrServicesForm?.get('serial_nos')){
      this.serialNumbers = this.availableLocations?.filter((data: any)=> data?.location?.location_uid === location_uid)[0]?.serial_nos;
      this.updatePartsOrServicesForm?.get('serial_nos')?.setValue([]);
    }
  }

  markupValueChange(event): void{
    this.markupEventAnalyticsService.trackEventAnalytics(this.data?.module);
  }

  changeMarkupType(type): void{
    this.markupEventAnalyticsService.trackEventAnalytics(this.data?.module);
    this.markupType = type;
    const markupValue = this.updatePartsOrServicesForm.controls.markup.value;
    if(!this.utilityService.isEmptyOrUndefined(markupValue)){
      this.updateSellingPrice(markupValue);
    }
  }

  updateSellingPrice(markupValue: number): void{
      if(markupValue>=0 && markupValue !== null) {
        let updatedSellingPrice: number = 0;
        switch (this.markupType) {
          case 'FLAT':
            updatedSellingPrice = this.purchasePrice + markupValue;
            break;
          case 'PERCENTAGE':
            updatedSellingPrice = this.purchasePrice + (this.purchasePrice * (markupValue / 100));
            break;
          case 'MULTIPLIER':
            updatedSellingPrice = this.purchasePrice * markupValue;
            break;
          default:
            break;
        }
        if (updatedSellingPrice >= 0) {
          const fixedDecimalSellingPrice = updatedSellingPrice.toFixed(this.currencyDecimal);
          this.updatePartsOrServicesForm.controls?.['price'].setValue(fixedDecimalSellingPrice);
          if(!this.utilityService.isEmptyOrUndefined(this.updatePartsOrServicesForm?.controls.markup.value)) {
            this.updatePartsOrServicesForm?.controls.price.disable();
          }
        }
      } else {
        this.updatePartsOrServicesForm.controls?.markup.markAsTouched();
        if(this.isEditSellingPriceDisabled === false){
          this.updatePartsOrServicesForm?.controls.price.enable();
        }
        if(!this.utilityService.isEmptyOrUndefined(this.updatePartsOrServicesForm.controls?.purchase_price?.value)){
          this.updatePartsOrServicesForm.controls?.['price'].setValue(this.purchasePrice);
        }
      }
  }

  ngOnDestroy(): void{
    if(this.markupValueSubscription){
      this.markupValueSubscription.unsubscribe();
    }
  }

}
